module.exports = __webpack_public_path__ + "static/media/Mapa-Piauí.cb6f5cdb.svg";